import { Component, OnInit, Input } from "@angular/core";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "refunds-admin",
  templateUrl: "refundsAdmin.component.html",
})
export class RefundsAdminComponent implements OnInit {
  public loading = false;
  public model: any = {};
  public messages: any;
  public refunds: any = [];
  public circles: any = [];

  constructor(
    private dataService: DataService,
    private alertService: AlertService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  validateRefund(refund) {
    let errorMessage = "";
    if (!refund) errorMessage = "אין מידע";
    else if (refund.circleId === undefined) errorMessage = "בחר מעגל";
    else if (
      !refund.fromHoursNew ||
      refund.fromHoursNew < 0 ||
      !refund.refundPercentNew ||
      refund.refundPercentNew < 0
    )
      errorMessage = "חייב מספר";
    else if (refund.toHoursNew && refund.fromHoursNew > refund.toHoursNew)
      errorMessage = "יחס לא תקין של שעות";
    return errorMessage;
  }

  saveRecord(refund) {
    let errorMessage = this.validateRefund(refund);
    if (errorMessage != "") {
      console.error(errorMessage);
      this.alertService.error(errorMessage);
    } else {
      this.loading = true;
      let refundData = {
        circleId: refund.circleId,
        fromHours: refund.fromHoursNew,
        toHours: refund.toHoursNew,
        refundPercent: refund.refundPercentNew,
      };
      if (refund.id) refundData["id"] = refund.id;
      this.dataService.saveRefundData(refundData).subscribe(
        (data) => {
          this.loading = false;
          this.alertService.success("נשמר בהצלחה");

          if (this.circles && this.circles.length) {
            this.circles.forEach((c) => {
              if (c.circleId == refundData.circleId)
                refund.circleName = c.circleName;
            });
          }
          refund.fromHours = data.fromHours;
          refund.toHours = data.toHours;
          refund.refundPercent = data.refundPercent;
          refund.edit = false;
        },
        (error) => {
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.messages[body.statusText]
                ? this.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
          this.loading = false;
        }
      );
    }
  }

  deleteRecord(refund, index) {
    let result = window.confirm("האם אתה בטוח שאתה רוצה למחוק?");
    if (result) {
      this.loading = true;
      this.dataService.deleteRefundData({ refundId: refund.id }).subscribe(
        (data) => {
          this.loading = false;
          this.alertService.success("נמחק בהצלחה");
          this.refunds.splice(index, 1);
        },
        (error) => {
          let body = error.json && error.json();
          this.alertService.error(
            body && body.statusText
              ? this.messages[body.statusText]
                ? this.messages[body.statusText]
                : decodeURIComponent(body.statusText)
              : (error && error.statusText) || error
          );
          this.loading = false;
        }
      );
    }
  }

  openEditMode(refund) {
    if (this.refunds && this.refunds.length) {
      this.refunds.forEach((r) => {
        if (r.id != refund.id) r.edit = false;
      });
    }
    refund.edit = true;
    // 	refund['circle'] = {circleId:refund.circleId,circleName:refund.circleName};
    refund.fromHoursNew = refund.fromHours;
    refund.toHoursNew = refund.toHours;
    refund.refundPercentNew = refund.refundPercent;
  }

  newRecord() {
    this.refunds.push({ edit: true });
  }

  ngOnInit() {
    this.loading = true;
    this.dataService.getRefundsData().subscribe(
      (data) => {
        this.loading = false;
        this.refunds = data && data.refunds ? data.refunds : [];
        //  					if (this.refunds && this.refunds.length){
        //  						this.refunds.forEach((r) => {
        //  							r['circle'] = {circleId:r.circleId,circleName:r.circleName};
        //  						});
        //  					}
        this.circles = data && data.circles ? data.circles : [];
      },
      (error) => {
        this.alertService.error(
          error && error.statusText
            ? decodeURIComponent(error.statusText)
            : error
        );
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/refunds/refundsAdmin.component.ts